import { userRoles } from './UserRole'

const { admin, adops, backOffice, customerPerformance, customerSuccess, publisher } = userRoles

export type UserGroup = keyof typeof userGroupRoles
export type UserGroupRoles = typeof userGroupRoles

export const userGroupRoles = {
  employeesOnly: [admin, adops, backOffice, customerPerformance, customerSuccess],
  everyone: [admin, adops, backOffice, customerPerformance, customerSuccess, publisher],
} as const
